import { UpdateClientRequest } from '../../../../web-api-client';
import { Client } from '../../models';

export const mapClientToUpdateRequest = (
  client: Client
): UpdateClientRequest => {
  return new UpdateClientRequest({
    clientId: client.clientId,
    name: client.name,
    description: client.description,
    isActive: client.isActive,
  });
};
